import Vue from 'vue'
import { formatEvent, formatFetchParamsFromQuery } from '~/assets/util/formatters'

export const state = () => {
	return {
		data: [],
		total: 0,
		sharedToken: null,
		history: {},
		userFeedbackRate: null,
		TFSurveyShown: false,
		closedFeedbackQuantity: 0,
		tagsBubble: [],
		upcomingLiveEvents: {
			total: 0,
			data: []
		}
	}
}

const initialState = Object.assign({}, state())

export const getters = {
	canLoadMore ({ data, total }) {
		return data.length < total
	},
	canLoadMoreUpcoming ({ upcomingLiveEvents }) {
		return upcomingLiveEvents.data.length < upcomingLiveEvents.total
	}
}

export const actions = {
	async fetchEvents ({ commit }, { query, loadMore = false }) {
		try {
			const params = formatFetchParamsFromQuery(query)
			const { data, meta } = await this.$axios.$get('/api/v1/events?status=vod,live', { params })

			this.$log.debug('[EventsStore] Got `events` from API', data)

			let events = data.map(formatEvent)
			// need to filter events without hd source, only upcoming_live can have such case
			events = events.filter(event => event.source?.hd)

			commit('setTotal', meta.total)

			loadMore
				? commit('addEvents', events)
				: commit('setEvents', events)
			// added to always showing live events in the top
			commit('sortEvents')
		} catch (error) {
			commit('setEvents', [])
			commit('setTotal', 0)
			this.$log.error('[EventsStore] Error during `fetchEvents` action', error)
		}
	},
	async fetchUpcomingEvents ({ commit }, { query, loadMore = false }) {
		try {
			const params = formatFetchParamsFromQuery(query)
			const { data, meta } = await this.$axios.$get('/api/v1/events?status=upcoming_live', { params })

			this.$log.debug('[EventsStore] Got `upcoming events` from API', data)

			const events = data.map(formatEvent)

			commit('setTotalUpcoming', meta.total)

			loadMore
				? commit('addUpcomingEvents', events)
				: commit('setUpcomingEvents', events)
		} catch (error) {
			commit('setUpcomingEvents', [])
			commit('setTotalUpcoming', 0)
			this.$log.error('[EventsStore] Error during `fetchEventsUpcoming` action', error)
		}
	},
	fetchTagsBubble ({ commit, state }, payload) {
		if (state.tagsBubble.includes(payload)) {
			return
		}

		commit('setTagsBubble', payload)

		const custom = { tagsBubble: state.tagsBubble }

		try {
			this.$axios.$patch('/api/v1/users/me', { custom })
		} catch (error) {
			this.$log.error('Failed to update tags bubble', error)
		}
	},
	markTFSurveyAsShown ({ commit }) {
		commit('setTFSurveyShown', true)

		const custom = { TFSurveyShown: true }

		try {
			localStorage.setItem('tf_survey_completed', 'true')
			this.$axios.$patch('/api/v1/users/me', { custom })
		} catch (error) {
			this.$log.error('Failed to survey completion', error)
		}
	}
}

export const mutations = {
	RESET_STORE: (state) => {
		// Do not need to clear the 'sharedToken', as it is used to watch events by users who arn`t club members.
		Object.assign(state, initialState, { sharedToken: state.sharedToken })
	},
	setSharedToken (state, token) {
		state.sharedToken = token
	},
	setEvents (state, events = []) {
		state.data = events
	},
	setUpcomingEvents (state, events = []) {
		state.upcomingLiveEvents.data = events
	},
	addEvents (state, events = []) {
		state.data = state.data.concat(events)
	},
	addUpcomingEvents (state, events = []) {
		state.upcomingLiveEvents.data = state.data.concat(events)
	},
	setTotal (state, total = 0) {
		state.total = total
	},
	setTotalUpcoming (state, total = 0) {
		state.upcomingLiveEvents.total = total
	},
	setEventsHistory (state, playback) {
		Vue.set(state.history, playback.id, playback.type)
	},
	setUserFeedbackRate (state, rate) {
		state.userFeedbackRate = rate
	},
	setTFSurveyShown (state, shown) {
		state.TFSurveyShown = Boolean(shown)
	},
	setClosedFeedbackQuantity (state) {
		state.closedFeedbackQuantity++
	},
	setTagsBubble (state, bubble = []) {
		if (JSON.stringify(state.tagsBubble) !== JSON.stringify(bubble)) {
			state.tagsBubble = state.tagsBubble.concat(bubble)
		}
	},
	sortEvents (state) {
		state.data.sort((a, b) => a.status < b.status ? -1 : 0)
	}
}
